/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

import { NestedOption } from '../../../core/nested-option';

import DevExpress from 'devextreme/bundles/dx.all';

export abstract class DxoHtmlEditorToolbar extends NestedOption {
    get container(): Element | JQuery {
        return this._getOption('container');
    }
    set container(value: Element | JQuery) {
        this._setOption('container', value);
    }

    get items(): Array<DevExpress.ui.dxHtmlEditorToolbarItem | string> {
        return this._getOption('items');
    }
    set items(value: Array<DevExpress.ui.dxHtmlEditorToolbarItem | string>) {
        this._setOption('items', value);
    }
}
